import FootballStatsCollection from "./football-stats-collection";

export default class FootballPeriodStatsCollection extends FootballStatsCollection {
    constructor(period, statLogs = []) {
        super(
            statLogs.filter((s) => {
                return s.period === period;
            })
        );
        this.period = period;
    }
}
